export default state => ({
  ...state,
  isPriority: false
});
